<template>
  <div class="wrapper">
    <div class="checkout-container">
      <h1>{{ title }}</h1>
      <div class="checkout">
        <div class="buyer-info">
          <user-container
            :user="user"
            :organization-type="organization.type"
            @refetchUser="handleRefetchUser"
          />
          <form v-scroll-to-error>
            <sport-organization-ticket-personalization
              :order="order"
              :schema="schema"
              :vs="$v"
              :buyer="buyer"
              :organization-id="organization && organization.id"
              :is-membership-purchase="isMembershipPurchase"
              :personalization-errors="personalizationErrors"
            />

            <sport-organization-buyer-form
              class="section-container"
              :buyer="buyer"
              :vs="$v"
            />
            <sport-organization-store-payment-methods class="section-container" :buyer="buyer" />
            <user-permissions
              class="section-container"
              style="border-top: 1px solid rgba(151, 151, 151, 0.5)"
              :vs="$v"
              :buyer="buyer"
              :organization="organization"
            />
            <div class="button-container">
              <main-button color="#0054A5" :disabled="!buyer.paymentMethod && order.reduce((sum, item) => sum + Number(item.price), 0) > 0" @click="handleSubmit">
                potvrdi narudžbu <v-icon style="color: white">chevron_right</v-icon>
              </main-button>
            </div>
          </form>
        </div>
        <div class="cart-timer">
          <sport-organization-store-timer :start-time="startedAt" />
          <sport-organization-shopping-cart
            ref="shoppingCart"
            :show-next="false"
            :order="order"
            class="shopping-cart"
            @edit="$emit('edit')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserContainer from '@/components/accreditations/organization-store/user/UserContainer.vue'
import { sameAs, required, email } from 'vuelidate/lib/validators'
import UserPermissions from '@/components/accreditations/organization-store/store-checkout/components/UserPermissions.vue'
import SportOrganizationShoppingCart from '@/components/accreditations/organization-store/shopping-cart/SportOrganizationShoppingCart.vue'
import SportOrganizationStorePaymentMethods from '@/components/accreditations/organization-store/store-checkout/components/SportOrganizationStorePaymentMethods.vue'
import SportOrganizationBuyerForm from '@/components/accreditations/organization-store/store-checkout/components/SportOrganizationBuyerForm.vue'
import SportOrganizationStoreTimer from '@/components/accreditations/organization-store/store-checkout/components/SportOrganizationStoreTimer.vue'
import SportOrganizationTicketPersonalization
from '@/components/accreditations/organization-store/store-checkout/components/SportOrganizationTicketPersonalization.vue'

export default {
  name: 'sport-organization-checkout-container',
  components: {
    SportOrganizationTicketPersonalization,
    SportOrganizationStoreTimer,
    SportOrganizationBuyerForm,
    SportOrganizationStorePaymentMethods,
    SportOrganizationShoppingCart,
    UserPermissions,
    UserContainer,
  },
  props: {
    user: {
      type: Object,
      default: null,
    },
    buyer: {
      type: Object,
      default: null,
    },
    organization: {
      type: Object,
      default: null,
    },
    order: {
      type: Array,
      default: () => [],
    },
    startedAt: {
      type: String,
    },
    schema: {
      type: Object,
      default: () => ({}),
    },
    title: String,
  },
  validations() {
    return {
      buyer: {
        firstName: {
          required,
        },
        lastName: {
          required,
        },
        email: {
          required, email,
        },
        address: {
          required,
        },
        acceptTermsAndConditions: {
          sameAs: sameAs(() => true),
        },
        personalization: {
          $each: {
            ...this.schema.validationSchema,
          },
        },
      },
    }
  },
  data() {
    return {
      personalizationErrors: {
        index: 1,
        error: false,
      },
    }
  },
  computed: {
    isMembershipPurchase() {
      return this.$route.name === this.routes.shared.sportMembershipsStore
    },
  },
  methods: {
    handleRefetchUser() {
      this.$emit('refetchUser')
    },
    handleSubmit() {
      if (!this.buyer.paymentMethod && this.$refs.shoppingCart.getTotalPrice() > 0) return
      this.$v.$touch()

      this.personalizationErrors.index++
      this.personalizationErrors.error = this.$v.buyer.personalization.$invalid

      if(this.$v.$invalid) {
        return
      }


      this.$emit('submit')
    },
  },
}
</script>

<style scoped>
.wrapper {
  display: flex;
  justify-content: center;
  padding: 2rem 7rem;
}
.checkout-container {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
}
h1 {
  color: #333;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 36px;
  font-style: normal;
  font-weight: 800;
  line-height: 120%; /* 43.2px */
  letter-spacing: -1.08px;
}
.checkout {
  display: flex;
  gap: 1.5rem;
}
.button-container {
  display: flex;
  justify-content: flex-end;
  padding: 1.5rem;
  background: rgba(0, 130, 255, 0.1);
}
.section-container {
  padding: 2rem 1.5rem 2.5rem 1.5rem;
  margin-top: 1.94rem;
}
.buyer-info {
  flex: 2;
  max-width: 800px;
}
.cart-timer {
  flex: 1;
  max-width: 400px;
}
@media screen and (max-width: 1024px) {
  .buyer-info {
    max-width: 100%;
  }
  .checkout {
    flex-direction: column;
  }
  .wrapper {
    padding: 2rem 2rem;
  }
  .cart-timer {
    max-width: 100%;
  }
}
@media screen and (max-width: 800px) {
  .wrapper {
    padding: 2rem 0;
  }
}
.shopping-cart {
  margin-top: 1.5rem;
}
</style>
